// src/components/MobileGuard.tsx
import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import i18n from '@/i18n/config';
import { isMobile } from '@/utils/device';
export const MobileGuard = ({ children }: { children: React.ReactNode }) => {
  // const location = useLocation();

  useEffect(() => {
    const checkDevice = () => {
      // 统一复用 @/utils/device 的判定，避免两套标准各说各话。
      // 原实现是 `'ontouchstart' in window || maxTouchPoints > 0 || innerWidth <= 768`，
      // 任何触屏设备（含全部平板、触屏笔记本）都会弹"请用 PC 访问"，误报严重。
      if (isMobile()) {
        let WARNING_KEY = 'singleton-warning-key';
        let text = i18n.t('common.mobileWarning');
        message.open({
          key: WARNING_KEY,
          type: 'warning',
          content: text,
          duration: 4, // 可选，默认 3 秒
        });
      }
    };

    // 监听窗口大小变化
    window.addEventListener('resize', checkDevice);

    // 清理事件监听器
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  // 检查当前是否为登录页面
  // const isLoginPage = location.pathname === '/login';

  return (
    <>
      {/* {isMobile && !isLoginPage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: '12px 16px',
            fontSize: '14px',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#ff6b35',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          为更好的使用体验，请使用 PC 端浏览器访问网站
        </div>
      )} */}
      {/* <div style={isMobile && !isLoginPage ? { paddingTop: '48px' } : {}}>{children}</div> */}
      <div>{children}</div>
    </>
  );
};
